
const docR = ({ displayName, docId  }) => `
        <button data-resouce-id="${docId}" data-resouce-name="${displayName}" class="btn btn-dusk-outline  btn-selecter btn-selecter--thumb js-doc-select">
            ${displayName}
        </button>
`;



const timeOptions = ({ displayName, value }) => `
    <option value="${value}" data-name="${displayName}">${displayName}</option>
`;




export {
    docR,
    timeOptions
};
